// components/MultiPlatformPixelScript/index.tsx — MultiPlatformPixelScript composition
import React from 'react';
import type { MultiPlatformPixelScriptProps } from './types';
import { useMultiPlatformPixels } from './hooks';
import { MetaNoscriptFallback } from './fallback';

const MultiPlatformPixelScript: React.FC<MultiPlatformPixelScriptProps> = ({ configs, contentName, contentIds, pageType, orderData, value, userData, embedMode, eventId }) => {
    useMultiPlatformPixels({ configs, contentName, contentIds, pageType, orderData, value, userData, embedMode, eventId });

    return <MetaNoscriptFallback configs={configs} contentName={contentName} orderData={orderData} />;
};

export default MultiPlatformPixelScript;
